import { ComponentPropsWithRef, forwardRef } from 'react';

import { SeparatorStyled } from './Separator.styles';

export interface SeparatorProps extends ComponentPropsWithRef<'div'> {
  disable?: boolean;
}

export const Separator = forwardRef<HTMLDivElement, SeparatorProps>(({ disable, ...props }: SeparatorProps, ref) => {
  return <SeparatorStyled ref={ref} aria-disabled={disable} {...props} />;
});

Separator.displayName = 'Separator';
